import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Phd-dlit</h1>
                <p>Home &gt; Phd-dlit</p>
            </div>
        </div>
    )
}

export default Hero;